import * as React from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useInstance } from "easy-redux-http-call";
import { useAIEventHandler } from "easy-redux-http-call/dist/index";
import { Divider, IconButton ,Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CommonButton from "components/common-component/Button";
import { AI_getUserData } from "APIs/user";
import NotesIcon from "@mui/icons-material/Notes";
import { Delete, OpenInNew, Download } from "@mui/icons-material";
import { EditorState, RichUtils, ContentState } from "draft-js";
import { ReactComponent as Files } from "../../assets/images/icons/files.svg";
import commonFileIcon from "../../assets/images/icons/dummyFile.png";

import "draft-js/dist/Draft.css";
import {
  AI_addProjectEmployeeNotes,
  AI_setWorkingProject,
  AI_showProjectEmployeeList,
} from "APIs/projectEmployee";
import DraftEditor from "./Draft/Draft";
import { matchPath, useParams } from "../../../node_modules/react-router-dom/dist/index";
import {
  AI_addHandover,
  AI_deleteHandoverFiles,
  AI_getHandoverEmpList,
  AI_uploadHandoverFiles,
} from "APIs/handoverEmployee";
import AttachmentViewer from "components/Kanban/Card/CardDetails/AttachmentViewer";
import { Alert, Snackbar } from "../../../node_modules/@mui/material/index";
import ConfirmDeleteDialog from "components/common-component/ConfirmDeleteDialog";
import { getElapsedFormattedTime } from "utils/HelperFuncation";

const useStyle = makeStyles((theme) => ({
  marginLeft: {
    marginLeft: "20px",
  },
  dialog: {
    position: "absolute",
    // top: 50,
    maxHeight: "calc(100% - 220px)",
    overflowY:"auto",
    height:"max-content",
    // width: 800,
    width: 730,
    overflow: "hidden",
    [theme.breakpoints.between("xs", "sm")]: {
      width: "80%",
    },
  },
  hrDialogTitle: {
    display: "flex",
    gap: "10px",
  },
  hrDialogSubTitle: {
    textAlign: "left",
  },
  hrClosebtn: {
    position: "absolute",
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
  noticeContainer: {
    height: "auto",
    // minHeight:"20vh !important"
    // color:
  },
  DropButton: {
    margin: "0px",
    marginTop: "5px",
    padding: "11px 36px",
    borderRadius: "10px",
    backgroundColor: "#E27534",
    color: "white",
    "& > span > svg": {
      fill: "white",
    },
    "&:hover": {
      backgroundColor: "grey",
    },
  },
}));
const ProjectNotes = (props) => {
  const { employeeid } = useParams();
  const classes = useStyle();
  const imageArray = [
    "/home/user/Downloads/1736402008552_pexels-photo-326212.jpeg",
    "https://images.unsplash.com",
    "https://images.unsplash.com/photo-3",
    "https://images.unsplash.com/photo-4",
    "https://images.unsplash.com/photo-5",
    "https://images.unsplash.com/photo-6",
    "https://images.unsplash.com/photo-7",
    "https://images.unsplash.com/photo-8",
    "https://images.unsplash.com/photo-9",
    "https://images.unsplash.com/photo-10",
  ];

  const {
    openStatus = { open: false, id: null, notes: null, title: null },
    handleCloseAction = () => {},
    handleOpenStatus = () => {},
    readOnly = false,
    setIsreadOnly,
    noticeEmpNotes = "",
    noticeData = null,
    display = true,
    browseFile = false,
    handleActionCall = () => {},
    status = false,
    component = false
  } = props;
  const submitResponse = useInstance(AI_addProjectEmployeeNotes);
  const getUserData = useInstance(AI_getUserData);
  const projectDetails = useInstance(AI_showProjectEmployeeList);
  const setWorkingPorject = useInstance(AI_setWorkingProject);
  
  const [bugText, setBugText] = React.useState(null);
  const [summaryValidtion, setSummaryValidtion] = React.useState(
    {
      text: "",
      length: 0
    }
  );
  const [handoverStatus, setHandoverStatus] = React.useState(null);
  const [apiCall, setApiCall] = React.useState(null);
  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const [existingFiles, setExistingFiles] = React.useState([]);
  const [existingPath, setExistingPath] = React.useState([]);
  const [openViewer, setOpenViewer] = React.useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);
  const [action, setAction] = React.useState(false);
  const [showValidation, setShowValidation] = React.useState(false);
  const [attachmentPath, setAttachmentPath] = React.useState(null);
  const [attchmentIndex, setAttackmentIndex] = React.useState(null);
   const [message, setMessage] = React.useState(null);
    const [severity, setSeverity] = React.useState("success");
    const [messageOpen, setMessageOpen] = React.useState(false);
      const addHanover = useInstance(AI_addHandover);
  const [editorState, setEditorState] = React.useState(() =>
    EditorState.createEmpty()
  );

  const [formData, setFormData] = React.useState(new FormData());

  React.useEffect(() => {
    const updatedFormData = new FormData();

    // if (bugText && typeof bugText === "object") {
    // }
    if(noticeEmpNotes === "Edit"){
      updatedFormData.append("notes", JSON.stringify(bugText));
    }else if(noticeEmpNotes === "Add"){
      updatedFormData.append("notes", JSON.stringify(bugText));
    }
    updatedFormData.append(
      "project_id",
      Number(noticeData?.projectId || openStatus?.item?.project_id)
    );
    updatedFormData.append(
      "handover_employee_id",
      Number(noticeData?.userId || openStatus?.item?.handover_employee_id)
    );
    updatedFormData.append("is_submit", true);

    if (selectedFiles.length > 0) {
      selectedFiles.forEach((file) => {
        updatedFormData.append("task_files", file);
      });
    }

    if (existingPath?.length > 0) {
      updatedFormData.append("old_task_files", existingPath.join(","));
    }

    setFormData(updatedFormData);
  }, [selectedFiles, bugText,noticeEmpNotes]);

  const handleSubmit = () => {
    const updatedFormData = new FormData();
    if (noticeEmpNotes === "Edit") {
      if (!bugText || typeof bugText !== "object") {
        const defalut = {"blocks":[{"key":"eh9l8","text":" ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}
        updatedFormData.append("notes", JSON.stringify(defalut));
        // return alert("Bug text is missing or invalid!");
      }

      AI_addHandover.call({
        urlParams: { id: getUserData?.data?.user?.id },
        headers: { "Content-Type": "multipart/form-data" },
        params: formData,
      });
      
      setHandoverStatus(true);
      handleCloseAction();
      handleActionCall()

      return;
    }
    else if (noticeEmpNotes === "Add" && noticeData) {
      // const formData = new FormData();
      //     if(selectedFiles.length > 0 ){
      //   selectedFiles.forEach(async (file) => {
      //     formData.append("task_files", file)})}

      // AI_addHandover.call({
      //   urlParams: { id: getUserData?.data?.user?.id },
      //   params: {
      //     project_id: Number(noticeData?.projectId),
      //     handover_employee_id: Number(noticeData?.userId),
      //     notes: JSON.stringify(bugText),
      //     is_submit: true,
      //     task_files:formData && formData ? formData : null
      //   },
      // });
      const formData = new FormData();

      if (selectedFiles.length > 0) {
        selectedFiles.forEach((file) => {
          formData.append("task_files", file);
        });
      }

      formData.append("project_id", Number(noticeData?.projectId));
      formData.append("handover_employee_id", Number(noticeData?.userId));
      if (!bugText || typeof bugText !== "object") {
        const defalut = {"blocks":[{"key":"eh9l8","text":" ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}
        updatedFormData.append("notes", JSON.stringify(defalut));
        // return alert("Bug text is missing or invalid!");
      }else{
        formData.append("notes", JSON.stringify(bugText));
      }
      formData.append("is_submit", "true");

      AI_addHandover.call({
        urlParams: { id: getUserData?.data?.user?.id },
        headers: { "Content-Type": "multipart/form-data" },
        params: formData, // Pass FormData correctly
      });
      //   if(selectedFiles.length > 0 ){
      //     selectedFiles.forEach(async (file) => {
      //       formData.append("task_files", file);
      //       await AI_uploadHandoverFiles.call({
      //          headers: { "Content-Type": "multipart/form-data" },
      //          urlParams: Number(noticeData?.projectId) ,
      //          params: formData,
      //        });
      //     });
      //   }
      setAction("addNote")
      setHandoverStatus(true);
      handleCloseAction();
      handleActionCall()
      // setSelectedUser({})

      return;
    }
    else {
      AI_addProjectEmployeeNotes.call({
        params: {
          id: openStatus.id,
          employee_notes: bugText,
        },
      });
      return ;
    }

    // AI_addProjectEmployeeNotes.call({
    //   params: {
    //     id: openStatus.id,
    //     employee_notes: bugText,
    //   },
    // });
  };

  useAIEventHandler(AI_addProjectEmployeeNotes, {
    onSuccess: () => {
      handleCloseAction();
      if (getUserData?.data) {
        AI_showProjectEmployeeList.call({
          urlParams: { id: getUserData?.data?.user?.employee_id },
        });
      }
    },
  });

  // 🆕 Load existing files from API
  React.useEffect(() => {
    if (openStatus?.item?.task_files || openStatus?.item?.path) {
      setExistingFiles(openStatus?.item?.path_url);
    }
    if (openStatus?.item?.path) {
      setExistingPath(openStatus?.item?.path);
    }
  }, [openStatus]);

  const handleFileChange = async (event) => {
    event.preventDefault();
    const filesArray = Array.from(event.target.files);
    setSelectedFiles(filesArray);
    setMessage("File uploaded successfully!")
    setSeverity("success")
    setMessageOpen(true)
    if(noticeEmpNotes === "Add"){
      setExistingFiles(filesArray)
    }else if(noticeEmpNotes === "Edit"){
      // setExistingFiles((prev) => [...prev, ...filesArray]);
      setExistingFiles((prev) => Array.isArray(prev) ? [...prev, ...filesArray] : [...filesArray]);

    }else {
      setExistingFiles([]);
    }

    // setAllFiles((prev)=>[...prev,...filesArray])
    const formData = new FormData();

    if (existingPath.length > 0) {
      formData.append("old_task_files", existingPath.join(","));
    }
    filesArray.forEach(async (file) => {
      formData.append("task_files", file);
    });
    selectedFiles.forEach( async (file) => {
      formData.append("task_files", file);
    })
    if(openStatus?.item?.id){
      await AI_uploadHandoverFiles.call({
         headers: { "Content-Type": "multipart/form-data" },
         urlParams: { id: openStatus?.item?.id },
         params: formData,
       });
     setApiCall("upload");
    }else{
      setApiCall(null)
      console.log("API Params ID : ==>>  ",openStatus?.item?.id)
    }
  };
  // later on code ...
  // const CallMe = (indexes, filePath) => {
  //   if (indexes && existingFiles.length > 0) {
  //     const files = existingFiles?.filter((file, index) => file === filePath);

  //     // setExistingFiles(files)
  //   }
  // };

 
  const [filePaths,setFilePath] = React.useState(null)
  // console.log("filePaths===>>>>",filePaths)
  const [deleteIndex,setDeleteIndex] = React.useState(null)
  const handleDeleteFile = async (filePath, indexes) => {
    setFilePath(filePath)
    setShowConfirmDialog(true)
    setDeleteIndex(indexes)
  };
  const confirmAction = (status) => {
    if(status === true){
      setShowConfirmDialog(false)
      setMessage("File deleted successfully")
      setMessageOpen(true)
        let index;
        let matchedPath;
        matchedPath = existingPath.filter((_, i) => i !== deleteIndex);
        let newExistingFiles = [];
        if(existingFiles.length > 0){
          newExistingFiles =  existingFiles?.filter((file,index)=>
            index !== deleteIndex
          )
          setExistingFiles(newExistingFiles)
        }
        if (existingFiles && existingFiles.length > 0) {
          index = existingFiles.findIndex((file) => file === filePaths);
        }
        
        if (index !== -1 && existingPath) {
          matchedPath = existingPath.filter((_, i) => i === index);
        }

        try {
          AI_deleteHandoverFiles.call({
            urlParams: { id: openStatus?.item?.id },
            params: {
              deleted_task_files: filePaths,
              delete_file_path: deleteIndex,
            },
          });
        } catch (error) {
          console.error("Error deleting file:", error);
        }
    }else{
      setShowConfirmDialog(false)
    }
  }
  const handleBoldClick = () => {
    setEditorState(RichUtils.toggleInlineStyle(editorState, "BOLD"));
  };

  const handleItalicClick = () => {
    setEditorState(RichUtils.toggleInlineStyle(editorState, "ITALIC"));
  };

  React.useEffect(() => {
    if (employeeid) {
    }
  }, [employeeid]);
  React.useEffect(() => {
    if (openStatus.open === true) {
      const foundNote = projectDetails?.data?.rows.find(
        (row) => row.id === openStatus.id
      );
      const employeeNotes = foundNote?.employee_notes;
      setBugText(employeeNotes);
    }
  }, [openStatus.open, projectDetails?.data?.rows]);
  React.useEffect(() => {
    if (getUserData?.data && handoverStatus) {
      AI_getHandoverEmpList.call({
        urlParams: { id: getUserData.data.user.employee_id },
        params: { in_notice: true },
      });
      setHandoverStatus(false);
    }
  }, [handoverStatus]);
  const handleApiCall = () => {
    if (apiCall === "delete" && apiCall !== null) {
      // AI_getHandoverEmpList.call({
      //   urlParams: { id: getUserData.data.user.employee_id },
      //   params: { in_notice: true },
      // });
      // handleCloseAction();
      setApiCall(null);
      // handleOpenStatus();
      handleActionCall()
    }
    if (apiCall === "upload" && apiCall !== null) {
      // AI_getHandoverEmpList.call({
      //   urlParams: { id: getUserData.data.user.employee_id },
      //   params: { in_notice: true },
      // });
      setApiCall(null);
      // handleOpenStatus();
    }
  };
  React.useEffect(() => {
    setTimeout(() => {
      handleApiCall();
    }, 1000);
  }, apiCall);

  const handleAttachmentViewer = (src, index) => {
    setAttachmentPath(existingFiles);
    setAttackmentIndex(index);
    setOpenViewer(true);
  };
  const truncateFileName = (name, maxLength = 10) => {
    if (name.length <= maxLength) return name;
    const splitName = name.split(".");
    const extension = splitName.pop();
    const shortName = splitName.join(".").slice(-maxLength);
    return `...${shortName}.${extension}`;
  };
  useAIEventHandler(AI_uploadHandoverFiles, {
    onSuccess: (res) => {
      // handleCloseAction();
      // AI_getHandoverEmpList.call({
      //   urlParams: { id: getUserData.data.user.employee_id },
      //   params: { in_notice: true },
      // });
      // setMessage(false)
  // setMessageOpen(false)
  // setSeverity(null)
    },
  });
  //  useAIEventHandler(AI_deleteHandoverFiles, {
  //     onSuccess: (res) => {
  //       AI_getHandoverEmpList.call({
  //         urlParams: { id: getUserData.data.user.employee_id },
  //         params: { in_notice: true },
  //       });
  //       handleCloseAction()
  //     },
  //   });
const handleCloseAlert = () => {
  setMessage(null)
  setMessageOpen(false)
  setSeverity(null)
}
const handlePaste = async (event) => {
  const items = event.clipboardData.items;
  const formData = new FormData();

  for (const item of items) {
    if (item.type.startsWith("image/")) {
      const blob = item.getAsFile();
      if (blob) {
        const newFile = new File([blob], `pasted_${Date.now()}.${blob.type.split("/")[1]}`, { type: blob.type });
        formData.append("task_files", newFile);
        setExistingFiles((prev) => [...prev, newFile]);
      }
    }
  }

  if (formData.has("task_files")) {
    try {
      await AI_uploadHandoverFiles.call({
        headers: { "Content-Type": "multipart/form-data" },
        urlParams: { id: openStatus?.item?.id },
        params: formData,
      });
    } catch (error) {
      console.error("File upload failed:", error);
    }
  }
};
    const handlePunchInOut = async (e) => {

      if(summaryValidtion?.length < 10 || !summaryValidtion?.text?.trim()){
        // openStatus?.open = true
        // setSummaryValidtion({
        //   text:"",
        //   length:0
        // })
        setShowValidation(true)
        return ;
      }

        setShowValidation(false)

    if(getUserData?.data?.user?.is_login){
      const work_time = getElapsedFormattedTime()
      const task_time = localStorage.getItem('stopwatch-time')
      localStorage.setItem('endTaskTime',task_time);

      const currTaskId = localStorage.getItem("currentTaskId");
      localStorage.setItem('endTaskId',currTaskId);

      const params = {
        employee_id: getUserData?.data?.user?.employee_id,
          punchInOut: true,
          work_summary:bugText || null,
          // working_task_id:Number(currTaskId),
      }

      if(currTaskId){
        params.working_project_id = Number(openStatus?.item?.project_id)
        params.working_task_id = Number(currTaskId)
      }

      if(work_time){
          params.working_task_time = work_time
      }

     await AI_setWorkingProject.call({
        params
      })
      
 }
}
  useAIEventHandler(AI_setWorkingProject, {
      onSuccess: () => {
          openStatus.open = false
      },
    });

React.useEffect(()=>{
  if(addHanover.loading === true && (status === "deleteNote" || action === "addNote" || handoverStatus)){
    AI_getHandoverEmpList.call({
          urlParams: { id: getUserData?.data?.user?.employee_id },
          params: {
            in_notice: true,
          },
        });
  }
},[addHanover])

React.useEffect(()=>{

  const sanitizedText =
  bugText?.blocks?.map((block) => block?.text).join("\n") || "";

const trimmedText = sanitizedText?.trim();
const wordCount = trimmedText ? trimmedText?.split(/\s+/)?.length : 0;

setSummaryValidtion({
  text: trimmedText,
  length: wordCount,
});
// console.log(sanitizedText);
},[bugText]);

React.useEffect(()=>{
  if(summaryValidtion?.length >= 10){
    setShowValidation(false)
  }
},[summaryValidtion?.length]);

  return (
    <>
      <Dialog
        onPaste={handlePaste}
        open={openStatus.open}
        onClose={() => handleCloseAction()}
        classes={
          !browseFile ? { paper: classes.dialog } : classes.noticeContainer
        }
        fullWidth
      >
        <form
          noValidate
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
          style={{ height: "100%" }}
        >
          <DialogTitle>
            <div className={classes.hrDialogTitle}>
              <NotesIcon />
              <Typography variant="h4" className={classes.hrDialogSubTitle}>
                {!component ? "Notes" : ""} {openStatus?.title !== null && !component ? `(${openStatus?.title})` : openStatus?.title }
              </Typography>
            </div>
            <IconButton
              aria-label="close"
              onClick={() => handleCloseAction()}
              className={classes.hrClosebtn}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <Divider />
          <DialogContent
            style={{
              overflowY:"auto",
              // height: "calc(100% - 180px)",
              height: "max-content",
              padding: "0px 24px 20px 24px",
            }}
          >
            {/* <CommonTexField
            placeholder="Notes"
            multiline
            rows={5}
            value={bugText}
            onChange={(e) => {
              setBugText(e.target.value);
            }}
          /> */}
                      {
              component === "header" && showValidation && 
              
              <p style={{color:"red"}}>Please describe your work properly in a statement with minimum 10 words.</p>
            }
            <DraftEditor
              component={component}
              browseFile={browseFile}
              display={display}
              notes={openStatus.notes}
              setDraft={setBugText}
              readOnly={readOnly}
              setIsreadOnly={(e) => setIsreadOnly(e)}
            />
            {/* <div className="editor-toolbar">
            <button onClick={handleBoldClick}>Bold</button>
            <button onClick={handleItalicClick}>Italic</button>
          </div>
          <div className="editor-container">
            <Editor
              editorState={editorState}
              onChange={setEditorState}
              placeholder="Type something..."
            />
          </div> */}
              {
          component === "header" && (
            <>
            <div style={{display:"flex",justifyContent:"center"}}>
              <Button
              style={{height:"35px"}}
              variant="contained"
              color={getUserData?.data?.user?.is_login ? "error" : "success"}
              onClick={(event) => handlePunchInOut(event)}
            >
              {getUserData?.data?.user?.is_login ? "Punch-Out" : "Punch-In"}
            </Button>

            </div>

            </>
          )
        }
          </DialogContent>
          
          {/* <Box style={{height: "50px", width:"50px", display: "flex", justifyContent: "center", alignItems: "center"}}>
          images
        </Box> */}

          {/* </Box> */}
          {!readOnly && !component && (
            <DialogActions style={{marginRight:"65px"}}>
              <Button variant="outlined" onClick={() => handleCloseAction()}>
                Cancel
              </Button>
              <CommonButton
                variant="contained"
                loading={submitResponse.loading}
                type="submit"
                disabled={noticeEmpNotes === "Edit" && (!bugText || typeof bugText !== "object")}
              >
                Submit
              </CommonButton>
            </DialogActions>
          )}
        </form>
        {browseFile === true && !component && (
          <>
            <Box>
              {/* File Upload Input */}
              {!readOnly && (
                <>
                  <div
                    style={{
                      paddingBottom: "10px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <input
                      type="file"
                      multiple
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                      id="file-upload"
                    />

                    <label htmlFor="file-upload">
                      <Button
                        className={classes.DropButton}
                        startIcon={<Files style={{ color: "white" }} />}
                        variant="contained"
                        component="span"
                      >
                        Browse & Upload
                      </Button>
                    </label>
                  </div>
                </>
              )}
              {existingFiles?.length > 0 && (
                <>
                  <Box
                    // onPaste={handlePaste}
                    sx={{
                      alignItems: "center",
                      // justifyContent:"center",
                      display: "flex",
                      width: "33.8vw",
                      // paddingLeft:"10px",
                      // paddingRight:"10px",
                      height: "14vh",
                      overflowX: "scroll",
                      gap: 3,
                      mt: 3,
                      ml: 9.2,
                    }}
                  >
                    {existingFiles?.map((src, index) => {
                      const isLocalFile = src instanceof File; 
                      const fileSrc = isLocalFile
                        ? URL.createObjectURL(src)
                        : src; // Fix image src

                      return (
                        // ✅ Add return here
                        <Box
                          key={index}
                          sx={{
                            position: "relative",
                            // width: "100px",
                            // height: "60px",
                            flexShrink: 0,
                            cursor: "pointer",
                            "&:hover .overlay": { opacity: 1 },
                          }}
                        >
                          <Box
                            sx={{
                              position: "relative",
                              width: "100px",
                              height: "80px",
                              flexShrink: 0,
                              cursor: "pointer",
                              "&:hover .overlay": { opacity: 1 },
                            }}
                          >
                            <img
                              src={fileSrc}
                              alt={`Existing File ${index + 1}`}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = commonFileIcon;
                              }}
                              style={{
                                width: "100%",
                                height: "60px",
                                borderRadius: "8px",
                                objectFit: "cover",
                              }}
                            />

                            {/* Filename Below */}
                            <Tooltip title={isLocalFile ? src.name : src?.split("?")[0]?.split("/")?.pop()} arrow>
                              <Typography
                                variant="caption"
                                sx={{
                                  display: "block",
                                  textAlign: "center",
                                  width: "100%",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {isLocalFile ? src.name : src.split("/").pop()}
                              </Typography>
                            </Tooltip>

                            <Box
                              className="overlay"
                              sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "60px",
                                background: "rgba(0, 0, 0, 0.5)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 1,
                                borderRadius: "8px",
                                opacity: 0,
                                transition: "opacity 0.3s",
                              }}
                            >
                              <IconButton
                                sx={{ color: "white" }}
                                size="small"
                                onClick={() =>
                                  handleAttachmentViewer(src, index)
                                }
                              >
                                <OpenInNew fontSize="small" />
                              </IconButton>
                              <IconButton
                                sx={{ color: "white" }}
                                size="small"
                                component="a"
                                target="_blank"
                                href={src}
                                rel="noopener noreferrer"
                                download={`file_${index + 1}`}
                              >
                                <Download fontSize="small" />
                              </IconButton>
                              {!readOnly && (
                                <IconButton
                                  sx={{ color: "white" }}
                                  size="small"
                                >
                                  <Delete
                                    fontSize="small"
                                    onClick={() => handleDeleteFile(src, index,true)}
                                  />
                                </IconButton>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      )
                  })}
                </Box>
                </>
              )}
              {openViewer && (
                <AttachmentViewer
                  onClose={() => setOpenViewer(false)}
                  attachments={attachmentPath}
                  defaultIndex={attchmentIndex}
                />
              )}
           {message && (
  <Snackbar
    open={messageOpen}
    autoHideDuration={3000}
    onClose={handleCloseAlert}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
  >
    <Alert onClose={handleCloseAlert} severity={severity || "success"} style={{backgroundColor:"rgb(237, 247, 237)",color:"#1E4620"}} variant="filled">
      {message}
    </Alert>
  </Snackbar>
)}
<ConfirmDeleteDialog
        openStatus={showConfirmDialog}
        confirmAction={(status) => confirmAction(status)}
        confirmText={"Are you sure you want to delete this attachment?"}
      />

            </Box>
          </>
        )}
      </Dialog>
    </>
  );
};

export default ProjectNotes;
